import React from 'react';
import '../components/Pricing.css';
import PricingComponent from '../components/Pricing';

const PricingPage: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/pricing.jpg')" }}>
        <h1 className="animate-fade-up">Our Packages</h1>
        <p className="hero-subtitle animate-fade-up delay-200">Transparent Pricing for Your Business Growth</p>
      </div>
      <div className="page-content">
        <PricingComponent />
      </div>
    </div>
  );
};

export default PricingPage;
